import { useState } from "react";
import { motion } from "framer-motion";

export const TeamSection = () => {
  const [imgOk, setImgOk] = useState(true);

  return (
    <section id="team" data-testid="team-section" className="py-14 lg:py-20 border-t border-white/10 bg-slate3/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-4"
        >
          <div className="relative max-w-sm mx-auto lg:mx-0">
            <div className="absolute -inset-2 rounded-xl border border-gold/25" aria-hidden="true" />
            {imgOk ? (
              <img
                src="/team-ravinder.png"
                alt="Ravinder Kumar, Founder, Globus Financial Services"
                data-testid="team-photo"
                onError={() => setImgOk(false)}
                className="relative w-full aspect-[4/5] object-cover rounded-lg border border-white/10"
              />
            ) : (
              <div
                data-testid="team-photo-placeholder"
                className="relative w-full aspect-[4/5] rounded-lg border border-white/10 bg-gradient-to-br from-[#0B2B55] to-[#0E7A5B] flex items-center justify-center"
              >
                <span className="font-serif text-6xl text-gold">RK</span>
              </div>
            )}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-8"
        >
          <p className="overline-label mb-4">Our Team</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-testid="team-name">
            Ravinder Kumar
          </h2>
          <p className="text-gold text-sm tracking-[0.2em] uppercase mt-2 mb-6" data-testid="team-designation">
            Founder, Globus Financial Services
          </p>
          <div className="space-y-4 text-[#A0AAB2] text-base md:text-lg leading-relaxed max-w-3xl">
            <p>
              Ravinder Kumar brings over 28 years of leadership experience across public-sector and private
              banking, microfinance, development finance, and business advisory. His experience spans business
              banking, retail credit, financial inclusion, corporate strategy, portfolio quality, and capability
              building.
            </p>
            <p>
              Having worked with institutions including Punjab National Bank, ICICI Bank, Satya Microcapital, and
              FINISH Society, he combines strong lending understanding with practical execution. At Globus
              Financial Services, he leads the structuring, lender engagement, and documentation support for
              corporate, MSME, and individual borrowing requirements.
            </p>
            <p>
              His approach is built on transparent guidance, disciplined execution, and long-term client
              relationships.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
